export default "__VITE_ASSET__C0_YkDkg__"